export default {
      id: "manually-start-shipment-usage",
      viewBox: "0 0 28 32",
      url: __webpack_public_path__ + "img/icons.svg#manually-start-shipment",
      toString: function () {
        return this.url;
      }
    }